import { FullscreenOverlay } from '@acies/ui';
import { ConfiguratorModel } from '../configurator.model';
import GeometryDialog from './geometry-dialog';

export default class GeometryOverlay extends FullscreenOverlay {
	#dialog!: GeometryDialog;
	public constructor() {
		super();
		// the listener is registered on the model, so it would otherwise run in its scope rather
		// than in this one
		this.geometryDialogShownChanged = this.geometryDialogShownChanged.bind(this);
		// Subscribed here rather than on connect, because an Observable tells its listeners about a
		// change and not about the value it already holds.
		ConfiguratorModel.geometryDialogShown.subscribe(this.geometryDialogShownChanged);
	}

	/** The dialog the overlay centres and dims the Configurator behind. */
	public get dialog(): GeometryDialog {
		if (!this.#dialog) {
			this.#dialog = new GeometryDialog();
		}
		return this.#dialog;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponent(this.dialog);
		this.geometryDialogShownChanged(ConfiguratorModel.geometryDialogShown.value);
	}

	/**
	 * Unsubscribes, because the model outlives the overlay.
	 *
	 * `ConfiguratorModel` is a module constant, so a listener it still holds is an overlay that has been removed and cannot be collected.
	 */
	protected override disconnected(): void {
		super.disconnected();
		ConfiguratorModel.geometryDialogShown.unsubscribe(this.geometryDialogShownChanged);
	}

	/** Shows the overlay while the model says the geometry dialog is shown, and takes it out of the layout while it does not. */
	private geometryDialogShownChanged(shown: boolean): void {
		this.visible = shown;
	}
}
customElements.define('cf-geometry-overlay', GeometryOverlay);
